import { combineLatest, Observable, Subscriber, Subscription } from 'rxjs';

import { AssetMiscDomainService } from '@apps/cmdb/domain/asset-misc-domain.service';
import { TypeAsset } from '@apps/cmdb/cmdb.constants';
import { EnrichedAssetApi } from '@apps/cmdb/api/models';
import { Tag } from '@apps/cmdb/models';

import { Assetify } from '../domain/assetify';
import { UtilsService } from '@common/services';

export const joinAssets = <T extends Assetify> (assetMiscDomainService: AssetMiscDomainService, typeAsset: TypeAsset, tags: Tag[]) =>
{
    return function (source: Observable<T[]>): Observable<T[]>
    {
        return new Observable((subscriber: Subscriber<T[]>): Subscription =>
        {
            return combineLatest([source, assetMiscDomainService.getAll(typeAsset)])
                .subscribe({
                    next ([collection, assets]: [T[], EnrichedAssetApi[]]): void
                    {
                        const dico: Map<string, string[]> = new Map<string, string[]>();
                        assets.forEach((asset: EnrichedAssetApi): void =>
                        {
                            dico.set(asset.assetName.toUpperCase(), asset.tagIds);
                        });

                        const result = collection.map((item: T): T =>
                        {
                            const assetName = item.assetName();

                            item.tagIds = [];
                            if (!UtilsService.isNullOrEmpty(assetName))
                            {
                                if (dico.has(assetName.toUpperCase()))
                                {
                                    item.tagIds = dico.get(item.assetName());
                                    item.tagFullNames = tags
                                        .filter((tag: Tag): boolean => item.tagIds.includes(tag.tagId))
                                        .map((tag: Tag): string => tag.fullTagName)
                                        .join('|');
                                }
                            }

                            return item;
                        });

                        subscriber.next(result);
                    },
                    error (error): void
                    {
                        subscriber.error(error);
                    },
                    complete (): void
                    {
                        subscriber.complete();
                    }
                });
        });
    };
};
